import React from 'react';
import { Box, Typography, SxProps, Divider, Button, useTheme } from '@mui/material';
import { Switch } from '@europrocurement/flexy-components/components/atoms';

export const NotificationsPreferences: React.FunctionComponent = function () {
    const commonNotifItemStyle: SxProps = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    };

    const theme = useTheme();

    return (
        <>
            <Box p={2}>
                <Typography
                    component="h2"
                    variant="l2dh6"
                    sx={{
                        lineHeight: 1.4,
                    }}
                >
                    Préférences de notifications
                </Typography>
                <Typography
                    variant="l2dlabel"
                    color="text.secondary"
                >
                    Sélectionnez les types de notifications que vous souhaitez recevoir
                </Typography>
            </Box>

            <Box
                p={2}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 3,
                }}
            >
                <Box sx={{ ...commonNotifItemStyle }}>
                    <Typography variant="l2dbodys">
                        Nouveaux documents ajoutés aux dossiers
                    </Typography>
                    <Switch />
                </Box>
                <Box sx={{ ...commonNotifItemStyle }}>
                    <Typography variant="l2dbodys">
                        Nouvelles factures ajoutées aux dossiers
                    </Typography>
                    <Switch />
                </Box>
                <Box sx={{ ...commonNotifItemStyle }}>
                    <Typography variant="l2dbodys">Dossiers à compléter</Typography>
                    <Switch />
                </Box>
                <Box sx={{ ...commonNotifItemStyle }}>
                    <Typography variant="l2dbodys">Nouveaux messages</Typography>
                    <Switch />
                </Box>

                <Divider />

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'baseline',
                        justifyContent: 'start',
                        gap: '24px',
                    }}
                >
                    <Button
                        variant="text"
                        onClick={() => undefined}
                        sx={{
                            color: theme.palette.primary.dark,
                        }}
                    >
                        Annuler
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        onClick={() => undefined}
                        sx={{
                            backgroundColor: theme.palette.primary.dark,
                            marginTop: '15px',
                            padding: '15px 30px',
                            fontSize: '1rem',
                            borderRadius: '15px',
                            transition: 'background-color ease-in-out 300ms',
                            ':hover': {
                                backgroundColor: theme.palette.primary.main,
                            },
                        }}
                    >
                        Valider les modifications
                    </Button>
                </Box>
            </Box>
        </>
    );
};
